const SubdomainRow = () => null

export default SubdomainRow
